import React from "react";
import Pagetitle from "../elements/Pagetitle";
import Timeline from "../elements/Timeline";

const educationData = [
  {
    id: 1,
    title: "Acamedic Degree",
    years: "2020 - 2020",
    content:
      "Arkademy (Pijar Camp) - Fullstack Developer",
  },
  {
    id: 2,
    title: "Bachelor’s Degree",
    years: "2016 - 2021",
    content:
      "University of Muhammadiyah Jakarta - S1 Teknik Informatika",
  },
];

const experienceData = [
  {
    id: 1,
    title: "Fullstack Developer",
    years: "2021 - Present",
    content:
      "Indonesia Commodity & Derivatives Exchange (ICDX) - Fullstack Developer",
  },
  {
    id: 2,
    title: "Fullstack Developer",
    years: "2020 - 2021",
    content:
      "Dvoretsky Group - Fullstack Developer",
  },
];

function Experiences() {
  return (
    <section id="experience">
      <div className="container">
        <Pagetitle title="Experience" />
        <div className="row">
          <div className="col-md-6">
            <div className="timeline edu bg-white rounded shadow-dark padding-30 overflow-hidden">
              {educationData.map((education) => (
                <Timeline key={education.id} education={education} />
              ))}
              <span className="line"></span>
            </div>
          </div>

          <div className="col-md-6">
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
            <div className="timeline exp bg-white rounded shadow-dark padding-30 overflow-hidden">
              {experienceData.map((experience) => (
                <Timeline key={experience.id} education={experience} />
              ))}
              <span className="line"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experiences;
